import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-ads-detail',
  templateUrl: './help-google-ads-detail.component.html'
})
export class HelpGoogleAdsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
